<template>
  <div class="page-header level">
    <div class="level-left">
      <div class='size1-text pri-color'>Customers</div>
    </div>
    <div class="level-right"></div>
  </div>
  <div class="level">
    <div class="level-left">
      <div class="page-heading-label level-item">
          Per Page:
      </div>
      <div class="level-item">
        <select v-on:change="onPageSizeChanged()" id="page-size">
            <option value="10" selected="">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="200">200</option>
        </select>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <button id="export-button" v-on:click="onBtExport()" class="button is-secondary">
          Export to CSV
        </button>
      </div>
    </div>
  </div>
  <ag-grid-vue
      style="width: 100%; height: 600px;"
      class="ag-theme-alpine"
      id="myGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :columnDefs="columnDefs"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :defaultColDef="defaultColDef"
      :modules="modules"
      :rowData="rowData">
  </ag-grid-vue>

  <add-note
    :userId="selectedCustId"
    :businessName="selectedBusinessName"
    :showModal="showAddNote"
    @saved="saveNoteClicked"
    @cancelled="cancelAddNoteClicked">
  </add-note>
  <PageLoading :showLoading="!isReady"></PageLoading>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue3';
import { AllCommunityModules } from 'ag-grid-community';
import MoneyUtils from '@/shared/money-utils';
import GridUtils from '@/shared/grid-utils';
import AddNote from '@/components/add-note.vue';
import PageLoading from '@/components/page-loading.vue';

window.currencyFormatter = function currencyFormatter(params) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(params.value);
};
window.phoneFormatter = function phoneFormatter(params) {
  const str = params.value;
  // Filter only numbers from the input
  // eslint-disable-next-line prefer-template
  const cleaned = ('' + str).replace(/\D/g, '');

  // Check if the input is of correct
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    // Remove the matched extension code
    // Change this to format for any country code.
    const intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }

  return null;
};

window.einFormatter = function einFormatter(params) {
  const str = params.value;
  if (str && str.length === 9) {
    const prefix = str.substring(0, 2);
    const suffix = str.substring(2);
    return `${prefix}-${suffix}`;
  }
  return params.value;
};

window.dateFormatter = function dateFormatter(params) {
  const dateAsString = params.value;
  const dateParts = dateAsString && dateAsString.length > 0 ? dateAsString.split('-') : '';
  return (dateParts && dateParts.length >= 3)
    ? new Date(dateParts[0], dateParts[1] - 1, dateParts[2]).toLocaleDateString() : '';
};

export default {
  name: 'Customers',
  // eslint-disable-next-line vue/no-unused-components
  components: {
    AgGridVue,
    AddNote,
    PageLoading,
  },
  data() {
    return {
      gridOptions: {},
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      modules: AllCommunityModules,
      rowData: null,
      paginationPageSize: null,
      totalOustandingBilling: 0,
      cycleDate: '',
      statusMessage: '',
      showAddNote: false,
      selectedCustId: '',
      selectedBusinessName: '',
      isReady: false,
    };
  },
  mixins: [MoneyUtils, GridUtils],
  methods: {
    async fetchGridData() {
      await this.$store.dispatch('customers/fetchCustomersList');
      this.rowData = this.$store.state.customers.customers;
    },
    async onGridReady() {
      this.isReady = false;
      await this.fetchGridData();
      this.isReady = true;
    },
    onBtExport() {
      const expParams = {
        columnKeys: ['BusinessName', 'EIN', 'ContactName', 'BusinessPhone', 'Email', 'PastDueAmt', 'JoinDate'],
      };
      this.gridApi.exportDataAsCsv(expParams);
      // unfortunately, you need a commercial license of ag grid for this one.
      //      this.gridApi.exportDataAsExcel();
    },
    onPageSizeChanged() {
      const ps = document.getElementById('page-size').value;
      this.gridApi.paginationSetPageSize(Number(ps));
    },
    onToggleBillStatus(userId) {
      console.log(`on toggle bill status fired ${userId}`);
    },
    async saveNoteClicked() {
      console.log('save add note clicked!');
      this.showAddNote = false;
    },
    cancelAddNoteClicked() {
      console.log('cancel add note clicked');
      this.showAddNote = false;
    },

  },
  beforeMount() {
    // eslint-disable-next-line no-unused-expressions
    // this.gridOptions = {};
    this.columnDefs = [
      {
        field: 'BusinessName',
        editable: true,
        minWidth: 250,
      },
      {
        field: 'EIN',
        editable: true,
        minWidth: 30,
        // eslint-disable-next-line no-undef
        valueFormatter: einFormatter,
      },
      {
        field: 'ContactName',
        editable: true,
        headerName: 'Contact',
      },
      {
        field: 'BusinessPhone',
        headerName: 'Bus Phone',
        editable: true,
        maxWidth: 180,
        // eslint-disable-next-line no-undef
        valueFormatter: phoneFormatter,
      },
      {
        field: 'Email',
        headerName: 'Email',
        editable: true,
        minWidth: 220,
      },
      {
        field: 'PastDueAmt',
        headerName: 'Balance',
        editable: true,
        maxWidth: 140,
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        // eslint-disable-next-line no-undef
        // valueFormatter: currencyFormatter,
        cellRenderer: (params) => {
          const val = +params.value;
          const wrap = document.createElement('div');
          wrap.innerHTML = `${window.currencyFormatter(params)}`;
          if (val > 0) {
            wrap.classList.add('is-past-due');
            document.styleSheets[0].insertRule('.is-past-due { color: #D21515; }', 0);
          }

          return wrap;
        },
      },
      {
        field: 'JoinDate',
        headerName: 'Joined',
        editable: true,
        filter: 'agDateColumnFilter',
        filterParams: GridUtils.dateFilterParams,
        // eslint-disable-next-line no-undef
        valueFormatter: dateFormatter,
      },
      {
        field: 'UserID',
        headerName: '',
        sortable: false,
        filter: false,
        minWidth: 200,
        cellRenderer: (params) => {
          const wrap = document.createElement('div');

          const sep = document.createElement('span');
          sep.innerText = ' | ';

          const route = {
            name: 'customer-detail',
            params: { id: params.value, returnTo: 'customers' },
          };
          const detailsLink = document.createElement('a');
          detailsLink.href = this.$router.resolve(route).href;
          detailsLink.innerText = 'View Details';
          detailsLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.$router.push(route);
          });

          const addNoteLink = document.createElement('a');
          addNoteLink.href = '#';
          // console.log('Params are: ');
          // console.log(params.data.status);
          addNoteLink.innerText = 'Add Note';
          addNoteLink.addEventListener('click', async (e) => {
            e.preventDefault();
            this.selectedCustId = params.data.UserID;
            this.selectedBusinessName = params.data.BusinessName;
            this.showAddNote = true;
          });
          wrap.appendChild(detailsLink);
          wrap.appendChild(sep);
          wrap.appendChild(addNoteLink);
          return wrap;
        },
      },
    ];
    this.defaultColDef = {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: 'agTextColumnFilter',
      filterParams: GridUtils.textFilterParams,
      resizable: true,
    };
    this.paginationPageSize = 10;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  computed: {
  },
  props: {
  },
};

</script>

<style src='ag-grid-community/dist/styles/ag-theme-alpine.css'></style>
<style src='ag-grid-community/dist/styles/ag-grid.css'></style>
<style lang="scss" scoped>
    #export-button {
        font-weight: bold;
    }
    .status-message {
      background-color: green;
      color: #fff;
      min-height: 50px;
    }

@import "~ag-grid-community/src/styles/ag-grid.scss";
@import "~ag-grid-community/src/styles/ag-theme-alpine/sass/ag-theme-alpine-mixin";
.ag-theme-alpine {
    @include ag-theme-alpine((
        // use theme parameters where possible
        header-foreground-color: #FFF,
        header-background-color: #0F3D80,
        font-family: ('Helvetica', 'Arial', 'sans-serif'),
    ));
    .ag-icon {
      color: #FFF;
    }
    .ag-paging-button > .ag-icon {
        color: #000;
    }
    .ag-header-cell-text {
      font-size: 14px;
    }
}
  .pb-container {
    display: flex;
    justify-content: space-between;
  }
  .ipb-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tb {
    padding-left: 10px;
  }
  .tr {
    padding-left: 20px;
  }
  .page-heading-label {
      font-weight: 600;
      margin-top: 10px;
      line-height: 1.75;
      text-align: right;
      min-width: 0px;
      margin-bottom: 5px;
  }
</style>
